module.exports = __webpack_public_path__ + "img/stickman-3.cd0bf43e.svg";